import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

// ///////////////// LAZY LOAD ////////////////////////////
import Loadable from 'react-loadable';
import Loading from './common_components/Loading';

const AsyncMain = Loadable({
  loader: () => import('./bmc_components/Main'),
  loading: Loading,
});
// ////////////////////////////////////////////////////////

export default class Bmc extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Route render={(p) => <AsyncMain {...p} {...this.props} />} />
      </BrowserRouter>
    );
  }
}
